module.exports = __webpack_public_path__ + "img/sabadell-dark.db081be9.png";